import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { ThemeConfigKeys, ThemeConfigs, ScreensV2 } from './Constants';
import { DEFAULT_PATHS } from './ApiUtils';

export const useTheme = (themeKey: ThemeConfigKeys = ThemeConfigKeys.DefaultTheme) => {
  const location = useLocation();
  const [theme, setTheme] = useState(getThemeConfig(themeKey, location.pathname));

  useEffect(() => {
    setTheme(getThemeConfig(themeKey, location.pathname));
  }, [location, themeKey]);

  return theme;
};

const getThemeConfig = (key: ThemeConfigKeys = ThemeConfigKeys.DefaultTheme, location: string) => {
  let themeKey = key;
  let themeConfig = {};
    if (
    location.includes('-new') ||
    location.includes(ScreensV2.SearchManagerV2) ||
    location.includes(ScreensV2.TicketTLO) ||
    location.includes(ScreensV2.GlobalFilters) ||
    location.includes(ScreensV2.BookingCreateManagerV2) ||
    location.includes(ScreensV2.MarkupsV2) ||
    location.includes(ScreensV2.ShoppingDiagnosticsV2) ||
    location.includes(ScreensV2.BookingTolerances) ||
    location.includes(ScreensV2.IdentityProviderSettings) ||
    location.split('/')[1] === DEFAULT_PATHS.PROVIDER_CREDENTIALS ||
    location.split('/')[1] === DEFAULT_PATHS.ANCILLARY_DISTRIBUTION ||
    (location.split('/')[1] === 'ancillaries' && location.split('/')[2] === 'distribution') ||
    location.split('/')[1] === ScreensV2.Suppliers ||
    location.split('/')[1] === DEFAULT_PATHS.DIAGNOSTICS ||
    location.split('/')[1] === DEFAULT_PATHS.ACTIVITY_LOG
  ) {
    if (themeKey == ThemeConfigKeys.DefaultTheme) {
      themeKey = ThemeConfigKeys.DnataBlue;
    } else if (themeKey == ThemeConfigKeys.DefaultThemeSecondary) {
      themeKey = ThemeConfigKeys.DnataBlueCheckbox;
    }
    themeConfig = ThemeConfigs[themeKey];
  } else {
    themeConfig = ThemeConfigs[themeKey];
  }
  return themeConfig;
};
